// extracted by mini-css-extract-plugin
export var emptyState = "_4p-d";
export var statCard = "_4p-c";
export var table = "_4p-0";
export var tableCell = "_4p-4";
export var tableCellClickable = "_4p-5 _4p-4";
export var tableCellDefault = "_4p-6 _4p-4";
export var tableCellEmpty = "_4p-8";
export var tableCellWithValue = "_4p-7";
export var tableContainer = "_4p-e";
export var tableHeaderWeight = "_4p-1";
export var tableHeaderZone = "_4p-2";
export var tableRowHeader = "_4p-3";
export var viewModeButton = "_4p-9";
export var viewModeButtonActive = "_4p-a _4p-9";
export var viewModeButtonInactive = "_4p-b _4p-9";